import React, { Component } from 'react';

export default class Loading extends Component {
    render() {
        //Should get parent height
        let height = '100%';
        if (this.props.full_height) {
            height = `${window.innerHeight}px`;
        }

        let spinner_class = 'spinner-grow text-info';
        let spinner_style = { margin: '10px' };
        if (this.props.inline) {
            spinner_class = 'spinner-grow spinner-grow-sm';
            spinner_style = { marginRight: '4px' };
        }

        let loading_image = (
            <div>
                <div
                    className={`${spinner_class}`}
                    role="status"
                    style={Object.assign({}, spinner_style)}
                ></div>

                <div
                    className={`${spinner_class}`}
                    role="status"
                    style={Object.assign({}, spinner_style, {
                        animationDelay: '150ms',
                    })}
                ></div>

                <div
                    className={`${spinner_class}`}
                    role="status"
                    style={Object.assign({}, spinner_style, {
                        animationDelay: '300ms',
                    })}
                ></div>
            </div>
        );

        if (this.props.loaded) {
            return <div>{this.props.children}</div>;
        } else if (this.props.cover) {
            return (
                <div
                    style={{
                        position: 'relative',
                    }}
                >
                    {this.props.children}
                    <div
                        style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: height,
                            textAlign: 'center',
                            zIndex: '10',
                            background: 'rgba(255,255,255,.2)',

                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {loading_image}
                    </div>
                </div>
            );
        } else if (this.props.inline) {
            return (
                <div
                    style={{
                        display: 'inline-block',
                        height: height,
                        textAlign: 'center',
                        opacity: '.5',
                    }}
                >
                    {loading_image}
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: height,
                        textAlign: 'center',
                        padding: '10%',
                        zIndex: '10',
                        background: 'rgba(255,255,255,.2)',
                    }}
                >
                    {loading_image}
                </div>
            );
        }
    }
}
